import { render } from "./Workgallery.vue?vue&type=template&id=067a6545"
import script from "./Workgallery.vue?vue&type=script&lang=js"
export * from "./Workgallery.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__